import { Routes } from '@angular/router';

 
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import(`./features/jobs/job-page/job-page.component`)
      .then(mod => mod.JobPageComponent)
  }, 
  {
    path: 'login',
    loadComponent: () => import(`./features/login/login.component`)
      .then(mod => mod.LoginComponent),
  },
  {
    path: 'signup',
    loadComponent: () => import(`./features/signup/signup.component`)
      .then(mod => mod.SignupComponent)
  },

  {
    path: 'contact',
    loadChildren: () => import(`./features/contact/contact.routes`)
      .then(routes => routes.routes)
  },

  {
    path: 'about',
    loadChildren: () => import('./features/about/about.routes')
      .then(routes => routes.routes)
  },
  {
    path: 'price',
    loadChildren: () => import('./features/pricing-table/pricing.routes')
    .then(routes => routes.routes)
  },
  {
    path: 'jobs',
    loadChildren: () => import('./features/jobs/jobs.routes')
      .then(routes => routes.routes)
  },
  {
    path: 'talents',
    loadChildren: () => import('./features/jobs/candidates.routes')
      .then(routes => routes.routes)
  },
  {
    path: 'companies',
    loadChildren: () => import('./features/directories/directory.routes')
      .then(routes => routes.routes)
  },
  {
    path:'members',
    loadComponent: () => import(`./features/directories/members/members.component`)
    .then(mod => mod.MembersComponent )
  },
  // { 
  //   runGuardsAndResolvers: 'always',
  //   path: 'web',
  //   children: [
  //     {
  //       path: ':page',
  //       component: WebflowComponent,
  //       runGuardsAndResolvers: 'pathParamsChange',
  //     }
  //   ]
  // },

  { path: '**',
    redirectTo: ''
   }
]; 